import styled from 'styled-components';
import { NavItem } from 'reactstrap';

export const NavItemStyles = styled(NavItem)`
  a,
  div {
    display: flex;
    width: 12.75rem;
    height: 2.5rem;
    padding: 0 1rem;
    align-items: center;
    gap: 0.5rem;
    color: #74788d;
    font-size: 0.8125rem;
    font-style: normal;
    font-weight: 500;
    border-right: 1px solid #d9d9d9;
    cursor: pointer;

    ${({ active }) =>
      active &&
      `
        color: #556EE6;
        border-right: 1px solid #556EE6;
    `}
  }
`;

export const TabPaneStyles = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.5rem;
  flex: 1 0 0;

  span {
    color: #343a40;
    font-size: 1.01563rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;

export const ItemStyles = styled.div`
  display: flex;
  width: 37.5rem;
  padding: 0.5rem;
  gap: 1rem;
  border-radius: 0.25rem;
  border: 1px solid #d9d9d9;

  button {
    width: 2rem;
    height: 2rem;
    padding: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: 1rem;
    }
  }

  .btn-small {
    width: 2rem !important;
    height: 2rem !important;
  }

  .btn-small:hover {
    border: 1px solid #e2e8f0;
    background-color: #f7fafc;
  }

  span {
    color: #343a40;
    font-size: 0.8125rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  .btn {
    height: 2.5rem;
    padding: 0.625rem 1rem;
  }

  .btn-delete {
    color: #f46a6a;

    &:hover {
      background-color: rgba(244, 106, 106, 0.1);
    }
  }
`;
